module.exports = __webpack_public_path__ + "static/media/checked-icon-yellow2.38994eaf.svg";